import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const Ctx = createContext(null);
export function AppShellChromeProvider({ children }) {
    const [visible, setVisibleState] = useState(true);
    const setVisible = useCallback((v) => setVisibleState(v), []);
    const value = useMemo(() => ({ visible, setVisible }), [visible, setVisible]);
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useAppShellChrome() {
    const v = useContext(Ctx);
    if (!v) {
        return { visible: true, setVisible: () => undefined };
    }
    return v;
}
//# sourceMappingURL=useAppShellChrome.js.map